import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=bf5f67ac&scoped=true"
import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"
import style1 from "./overview.vue?vue&type=style&index=1&id=bf5f67ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5f67ac",
  null
  
)

export default component.exports